import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../theme/helpers/fontStyle';

export const $Row = styled(Row)`
  margin-bottom: ${spacing('lg')};
`;

export const $Col = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('lg')};
  padding: ${spacing('xxl')};
`;

export const $Footer = styled.footer`
  display: flex;
  gap: ${spacing(2.5)};

  & > *:first-child {
    font-size: ${({ theme }) => theme.fonts.size.huge};
    margin-top: ${spacing(1.5)};
  }

  @media ${media.maxWidth.sm} {
    align-self: start;
  }
`;

export const $Title = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  ${fontStyle('sm')};
  font-weight: ${fontWeight('bold')};
  text-transform: uppercase;
`;

export const $CenteredTitle = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  ${fontStyle('sm')};
  font-weight: ${fontWeight('bold')};
  text-transform: uppercase;
  text-align: center;
`;

export const $TakeHomePickupAppointmentHeader = styled.div`
  margin-bottom: ${spacing('lg')};
`;
